import firebase from "firebase";
// Initialize Firebase
var config = {
  apiKey: "AIzaSyClNJ8teMdgUFsBthvTgkZTz82RKvRWJyU",
  authDomain: "zarajskij-hleb.firebaseapp.com",
  databaseURL: "https://zarajskij-hleb.firebaseio.com",
  projectId: "zarajskij-hleb",
  storageBucket: "zarajskij-hleb.appspot.com",
  messagingSenderId: "879642220998",
  appId: "1:879642220998:web:1c5aa442896f82c6",
};
firebase.initializeApp(config);

export default firebase;
